import { app } from '../../../app';

app.constant('url', 'app/rest/applicationNonBlocked/:id');

app.factory('ApplicationService', ApplicationService);

/** @ngInject */
function ApplicationService($resource, url) {

    return $resource(url, {}, {
        'findAll': {
            method: 'GET',
            isArray: true,
        },
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/user/applications/applications.service.js